// extracted by mini-css-extract-plugin
module.exports =  {"c-selfad-single":"_025a50318d--c-selfad-single--mnKO8","c-selfad-single-content":"_025a50318d--c-selfad-single-content--cD8En"};